import catalog from "./en.json";

const walk = (node, path) =>
  path.split(".").reduce((acc, key) => (acc == null ? acc : acc[key]), node);

// A namespace may hold FLAT keys that contain dots themselves ("fb.av" and
// "fb.av.b" side by side), so a design deck's keys can be kept verbatim
// (the free-start deck, Req 14). The nested walk is tried first; only when it
// finds no string does the first segment name a flat namespace.
const lookup = (node, path) => {
  const nested = walk(node, path);
  if (typeof nested === "string") return nested;
  const dot = path.indexOf(".");
  if (dot < 0) return nested;
  const ns = node[path.slice(0, dot)];
  return ns && typeof ns === "object" ? ns[path.slice(dot + 1)] : undefined;
};

/**
 * Look up a catalog string by dotted key and interpolate `{name}` tokens.
 * A missing key is a programmer error — never fall back to the key itself.
 */
export function t(key, vars) {
  const value = lookup(catalog, key);
  if (typeof value !== "string") {
    throw new Error(`Missing copy key: ${key}`);
  }
  return value.replace(/\{(\w+)\}/g, (_, name) => {
    if (
      !vars ||
      !Object.prototype.hasOwnProperty.call(vars, name) ||
      vars[name] == null
    ) {
      throw new Error(`Missing copy interpolation: ${name} in ${key}`);
    }
    return String(vars[name]);
  });
}
